var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-logo"},[_c('img',{attrs:{"src":require("./logo.png"),"alt":""}}),_c('p',{staticClass:"subtitle"},[_vm._v(" 本服务由上海松鼠云上人工智能技术有限公司提供 ")])])
}]

export { render, staticRenderFns }